import { Component, Input, OnInit } from '@angular/core';
import { InvoiceStatisticsChartCardComponent } from 'gung-dashboard';

@Component({
    selector: 'colmec-invoice-statistics-chart-card',
    templateUrl: './colmec-invoice-statistics-chart-card.component.html',
    styleUrls: ['./colmec-invoice-statistics-chart-card.component.scss'],
    standalone: false
})
export class ColmecInvoiceStatisticsChartCardComponent extends InvoiceStatisticsChartCardComponent implements OnInit {
  @Input()
  preConditions: any;

  ngOnInit(): void {}
}
